import { render, staticRenderFns } from "./AdminTipiDocumentoIdentitaView.vue?vue&type=template&id=d3851312&"
import script from "./AdminTipiDocumentoIdentitaView.vue?vue&type=script&lang=ts&"
export * from "./AdminTipiDocumentoIdentitaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports